
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import DialogContentText from '@mui/material/DialogContentText';
import { DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Confirm from '@fuse/core/FuseDialog/confirm';
import Icon from '@mui/material/Icon';
import { useState, useEffect } from 'react';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { useDispatch, useSelector } from 'react-redux';
import FuseUtils from '@fuse/utils';
import { authPermissions } from 'app/auth';
import { deleteOrders, getOrders, sendInvoice } from 'app/main/apps/e-commerce/store/ordersSlice';
import dispatchMessage from 'app/main/apps/common/AuraFunctions';
import { showMessage } from "app/store/fuse/messageSlice";
import { getEcomWidgetsOrderItems } from 'app/main/dashboards/main/store/widgetsSlice';
import { capitalize } from 'lodash';
import { openOrderDialog, performAction } from '../store/orderSlice';
import { deleteShipments, getShipments, setSelectedShipments } from '../../backoffice/store/shipmentsSlice';
import { isArchivedView } from '../../common/archivedRecord';
import { selectionUnarchives } from './archiveSelection';


const useToolbarStyles = makeStyles((theme) => ({
  root: {
    minHeight: '45px',
    paddingLeft: '0px',
    color: theme.palette.text.primary,
  },
  colorBox: {},
}));

function OrdersToolBar(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useToolbarStyles();
  const { toggleAllRowsSelected, selectedRowIds, selectedFlatRows, toolbarParam } = props;
  const { options, stage } = toolbarParam
  const numSelected = Object.keys(selectedRowIds).length;
  const actionType = selectionUnarchives(options?.value, selectedFlatRows)
  const location = window.location.search
  const orderId = selectedFlatRows?.map(item => item.original?.id)
  const selectedShipmentIds = stage === "container" ? selectedFlatRows?.map(item => item?.original?.shipment_id) : [];
  const currentUser = useSelector(({ user }) => user);
  const { role } = currentUser
  const [loading, setLoading] = useState(false);
  const isManage =
      currentUser &&
      FuseUtils.hasPermission(authPermissions.manage, currentUser.role);

  function sendOrderInvoice() {
    const selectedRows = selectedFlatRows.map((d) => d.original);
    const data = selectedRows.map((d) => d.id);
    dispatch(sendInvoice({ oids: data })).then((response) => {
      if (response.error) {
        dispatchMessage(dispatch, 'Failed to send Invoice', 'error');
        toggleAllRowsSelected(false);
      } else {
        dispatchMessage(dispatch, 'Invoice sent successfully');
        toggleAllRowsSelected(false);
      }
    });
  }
  return (
    <>
      <Backdrop open={loading} style={{ zIndex: 1301, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {numSelected && numSelected > 0 ? (
      <Toolbar className={clsx(classes.root, 'flex items-start')}>
        <div className="flex flex-row items-center">
          <Box className="flex items-center font-medium font-bold">{numSelected}</Box>
          <Typography className="pl-8 font-medium" color="inherit">
            {toolbarParam.selectionMsg ? toolbarParam.selectionMsg : 'Row(s) Selected'}
          </Typography>
        </div>
        <div className="flex flex-row items-center">
          {/* This is commented as invoice genration done automatically  */}
          {/* <Button
            aria-label="Send Invoice"
            color="secondary"
            size="small"
            variant="contained"
            onClick={sendOrderInvoice}
            sx={{ padding: '0px 15px', marginLeft: '10px' }}
          >
            Send Invoice
          </Button> */}
        </div>
        {stage !== 'container' &&
        <Button
          color="secondary"
          size="small"
          variant="contained"
          sx={{ padding: '0px 15px', marginLeft: '10px' }}
          onClick={(ev) => {
            ev.stopPropagation();
            dispatch(
              openOrderDialog({
                completeOrderData: selectedFlatRows?.map(item => item.original),
                data: selectedFlatRows?.map(item => item.original),
                param: {
                  name: 'archive_notes',
                  title: actionType ? 'Unarchive Note' : 'Archive Note',
                  successMessage: `Selected items have been ${actionType ? 'restored' : 'archived'} successfully`,
                  showHeader: false,
                  showAutoNote: true, // Set this field for schema creation and display AutoNote field section in NoteFormCOntent
                  noteFieldName: "note", // Set this field for note field_name that will be sent to BE
                  noteIsRequired: true,
                  noteFieldLabelName: actionType ? 'Unarchive Note' : 'Archive Note', // Set this field for note field_name that will be sent to BE
                  orderId,
                  actionType,
                  options,
                  onSubmit: (formData) => {   // <-- pass callback for note submit
                    dispatch(performAction({
                      ui_id: "ARCHIVE",
                      data: {
                        order_ids: orderId,
                        is_archive: !actionType,
                        archive_reason:formData.note,  // the note from NoteFormContent
                      },
                    })).then(res => {
                      if (!res.error) {
                        dispatch(showMessage({
                          message: actionType ? 'Selected items have been restored' : 'Selected items have been moved to archive',
                          type: 'success',
                        }));
                        dispatch(getOrders({ params: { stage }, goToFirstPage: true }));
                      } else {
                        // Handle known error from response
                        dispatch(showMessage({
                          message: res.error?.message || 'An error occurred while archiving. Please try again.',
                          type: 'error',
                        }));
                      }
                       });
                  }
                },
                stage,
              })
            );
          }}
        >
          {actionType ? 'Unarchive' : 'Archive'}
        </Button>
        }
        {stage === 'order' && !isArchivedView(location) && <Button
          color="secondary"
          size="small"
          variant="contained"
          sx={{ padding: '0px 15px', marginLeft: '10px' }}
          onClick={() => {
            dispatch(
              openOrderDialog({
                data: {
                  order_ids: orderId
                },
                param: {
                  name: 'discount',
                  title: 'Update Discount',
                  successMessage: 'Your selected order(s) have been updated with a new discount!',
                  submitButtonName: "Update",
                  loadOrdersFun: () => dispatch(getOrders({ params: { stage }, goToFirstPage: true }))
                },
              })


            );
          }}
        >
          Update Discount
        </Button>
        }
        {['order', 'quote', 'rfq'].includes(stage) && role === 'admin' && (
            <Button
              color="secondary"
              size="small"
              variant="contained"
              sx={{ padding: '0px 15px', marginLeft: '10px' }}
              onClick={(e) => {
                e.stopPropagation();
                dispatch(
                  openDialog({
                    children: (
                      <Confirm title={`Delete ${capitalize(stage)}`}
                        content="Are you sure you want to permanently delete the selected item"
                        onSubmit={() => {
                          setLoading(true);
                          dispatch(deleteOrders({
                            order_ids: orderId,
                          })).then(res => {
                            setLoading(false);
                            if (!res.error) {
                              dispatch(showMessage({ message: "Selected items has been deleted successfully", type: 'success' }))
                              dispatch(getOrders({ params: { stage }, goToFirstPage: true }))
                            }
                          })
                        }}
                      />
                    ),
                  })
                );

              }}>
              {` Delete ${capitalize(stage)}`}
            </Button>
          )
        }
        {/* Reorder button applicable only for back order and reorder filter */}
        {stage=== 'order' && isManage && (location.includes('?back_order=true') || location.includes('?reorder=true')) && (
            <Button
              color="secondary"
              size="small"
              variant="contained"
              sx={{ padding: '0px 15px', marginLeft: '10px' }}
              onClick={(e) => {
                e.stopPropagation();
                navigate("/reorder", { state: { orderIds: orderId } });
              }}>
              Re-Order
            </Button>
          )
        }
        {stage === 'container' && currentUser?.role === "admin" && (
          <>
            <Button
              color="secondary"
              size="small"
              variant="contained"
              sx={{ padding: "0px 15px", marginLeft: "10px" }}
              onClick={(e) => {
                e.stopPropagation();
                dispatch(
                  openDialog({
                    children: (
                      <Confirm
                        title="Delete Container Shipment(s)"
                        content="Are you sure you want to permanently delete the selected container shipment(s)?"
                        onSubmit={() => {
                          setLoading(true);
                          dispatch(
                            deleteShipments({
                              shipment_ids: selectedShipmentIds,
                            })
                          ).then((res) => {
                            setLoading(false);
                            if (!res.error) {
                              dispatch(
                                showMessage({
                                  message:
                                    "Selected shipment(s) has been deleted successfully",
                                  type: "success",
                                })
                              );
                              toggleAllRowsSelected(false);
                              dispatch(getOrders({ params: { stage }, goToFirstPage: true }))
                            } else {
                              toggleAllRowsSelected(false);
                              dispatch(
                                showMessage({
                                  message:
                                    "Failed to delete selected shipment(s)",
                                  type: "error",
                                })
                              );
                            }
                          });
                        }}
                      />
                    ),
                  })
                );
              }}
            >
              Delete Shipment
            </Button>
          </>
        )}
      </Toolbar >
  ) : (
    <></>
  )}
  </>
  );
}

export default OrdersToolBar;
